import Main from './index.vue'


export default [
  { path: '/share', component: Main, meta: { auth: true } }
]